export default __webpack_public_path__ + "static/media/portfolio-madrid-6.289daa02.jpg";